// extracted by mini-css-extract-plugin
module.exports = {"container":"_2a1q-"};